// tslint:disable
// TODO: change `require`s to `import`s and add local tslint:disables

export const logo: string = require('./logo.svg').default;
export const logo_fr: string = require('./logo-fr.svg').default;
export const logo_mobile: string = require('./logo-mobile.svg').default;
export const arrow: string = require('./arrow.svg').default;
export const arrow_full: string = require('./arrow_full.svg').default;
export const arrowUp: string = require('./arrowUp.svg').default;
export const atMail_white: string = require('./at_mail_white.svg').default;
export const atMail_primary: string = require('./at_mail_primary.svg').default;
export const book: string = require('./book.svg').default;
export const calender: string = require('./calender.svg').default;
export const calling_full: string = require('./calling_full.svg').default;
export const calling_outline: string = require('./calling_outline.svg').default;
export const check: string = require('./check.svg').default;
export const ckeckbox: string = require('./ckeckbox.svg').default;
export const clock: string = require('./clock.svg').default;
export const close: string = require('./close.svg').default;
export const contact: string = require('./contact.svg').default;
export const copy: string = require('./copy.svg').default;
export const eye: string = require('./eye.svg').default;
export const facebook: string = require('./facebook.svg').default;
export const favourits: string = require('./favourits.svg').default;
export const fax: string = require('./fax.svg').default;
export const fax_outline: string = require('./fax-outline.svg').default;
export const financing: string = require('./financing.svg').default;
export const images: string = require('./images.svg').default;
export const information_full: string = require('./information_full.svg').default;
export const information_outline: string = require('./information_outline.svg').default;
export const letter: string = require('./letter.svg').default;
export const pdf: string = require('./pdf.svg').default;
export const position: string = require('./position.svg').default;
export const question: string = require('./question.svg').default;
export const reloaded: string = require('./reloaded.svg').default;
export const ring_bell: string = require('./ring_bell.svg').default;
export const sendMail: string = require('./sendMail.svg').default;
export const share_connection: string = require('./share_connection.svg').default;
export const share_full: string = require('./share_full.svg').default;
export const share_outline: string = require('./share_outline.svg').default;
export const smartphone: string = require('./smartphone.svg').default;
export const thumb_up: string = require('./thumb_up.svg').default;
export const twitter: string = require('./twitter.svg').default;
export const linkedin: string = require('./linkedin.svg').default;
export const user: string = require('./user.svg').default;
export const videos: string = require('./videos.svg').default;
export const zoom: string = require('./zoom.svg').default;
export const play: string = require('./play.svg').default;
export const be: string = require('./flags/land_belgien.svg').default;
export const bg: string = require('./flags/land_bulgarien.svg').default;
export const da: string = require('./flags/land_daenemark.svg').default;
export const de: string = require('./flags/land_deutschland.svg').default;
export const en: string = require('./flags/land_usa.svg').default;
export const fi: string = require('./flags/land_finnland.svg').default;
export const fr: string = require('./flags/land_frankreich.svg').default;
export const el: string = require('./flags/land_griechenland.svg').default;
export const it: string = require('./flags/land_italien.svg').default;
export const hr: string = require('./flags/land_kroatien.svg').default;
export const nl: string = require('./flags/land_niederlande.svg').default;
export const no: string = require('./flags/land_norwegen.svg').default;
export const at: string = require('./flags/land_oestereich.svg').default;
export const pl: string = require('./flags/land_polen.svg').default;
export const pt: string = require('./flags/land_portugal.svg').default;
export const ro: string = require('./flags/land_rumaenien.svg').default;
export const sv: string = require('./flags/land_schweden.svg').default;
export const ch: string = require('./flags/land_schweiz.svg').default;
export const es: string = require('./flags/land_spanien.svg').default;
export const cs: string = require('./flags/land_tschechien.svg').default;
export const hu: string = require('./flags/land_ungarn.svg').default;
export const ru: string = require('./flags/land_russland.svg').default;
export const sk: string = require('./flags/land_slowakei.svg').default;
export const si: string = require('./flags/land_slowenien.svg').default;
export const lv: string = require('./flags/land_lettland.svg').default;
export const lu: string = require('./flags/land_luxemburg.svg').default;
export const sr: string = require('./flags/land_serbien.svg').default;
export const gb: string = require('./flags/land_england.svg').default;
export const eu: string = require('./flags/europa.svg').default;
export const footer_busstore: string = require('./logos/Logo_BusStore.svg').default;
export const footer_mercedes: string = require('./logos/Logo_Mercedes-Benz.svg').default;
export const footer_omniplus: string = require('./logos/Logo_OMNIplus.svg').default;
export const footer_setra: string = require('./logos/Logo_Setra.svg').default;
export const footer_evobus: string = require('./logos/Logo_EvoBus.svg').default;

export {
    da as dk,
    el as gr,
    sv as se,
    cs as cz,
    lv as lt,
    sr as rs,
    en as us,
    be as belgien,
    bg as bulgarien,
    da as daenemark,
    de as deutschland,
    gb as england,
    fi as finnland,
    fr as frankreich,
    el as griechenland,
    it as italien,
    hr as kroatien,
    lv as lettland,
    lu as luxemburg,
    nl as niederlande,
    no as norwegen,
    at as oestereich,
    pl as polen,
    pt as portugal,
    ro as rumaenien,
    ru as russland,
    sv as schweden,
    ch as schweiz,
    sk as slowakei,
    si as slowenien,
    es as spanien,
    cs as tschechien,
    hu as ungarn,
    sr as serbien,
};
